import { render, staticRenderFns } from "./botaoCamera.vue?vue&type=template&id=45138828&scoped=true&"
import script from "./botaoCamera.vue?vue&type=script&lang=js&"
export * from "./botaoCamera.vue?vue&type=script&lang=js&"
import style0 from "./botaoCamera.vue?vue&type=style&index=0&id=45138828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45138828",
  null
  
)

export default component.exports